import styles from './MetropoleCCASHeader.module.css'

import {
  SvgOfficialLogoMetropole,
  SvgOfficialLogoCCASandVille,
} from '../../../svg/SvgComponents'

const MetropoleCCASHeader = () => (
  <>
    <header className={styles.header}>
      <div className={styles.logo}>
        <SvgOfficialLogoMetropole />
      </div>
      <div className={styles.logo}>
        <SvgOfficialLogoCCASandVille />
      </div>
    </header>
  </>
)

export default MetropoleCCASHeader

